var map = {
	"./casino/lang/conf.js": "DFIa",
	"./default/lang/conf.js": "4thb",
	"./marketmaker/lang/conf.js": "kXR7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lw+8";


//////////////////
// WEBPACK FOOTER
// ./src/companies ^\.\/.*\/lang\/conf\.js$
// module id = lw+8
// module chunks = 1